import { ErrorCodes } from '@storage/app/api'
import { useTranslate } from '@tolgee/react'
import { getAllErrorDescriptions } from '@tom-ui/utils'

export const useStowageInstructionMessageHandler = () => {
  const { t } = useTranslate()

  const getSuccessMessage = () => {
    return t('Success', 'Success')
  }

  const getExceptionMessage = (error: any) => {
    const errorDescriptions = getAllErrorDescriptions(error)

    const errors: string[] = []

    errorDescriptions.forEach(errorDescription => {
      if (errorDescription.code === ErrorCodes.EntityNotFound) {
        errors.push(
          t('entityNotFound', '{entity} with Id {id} not found', {
            entity: errorDescription.payload?.name,
            id: errorDescription.payload?.id,
          }),
        )
      }
    })

    if (errors.length > 0) return errors.join('\n')

    return error?.response?.data?.detail ?? t('somethingWentWrong', 'Something went wrong')
  }

  return {
    getExceptionMessage,
    getSuccessMessage,
  }
}
